import React from 'react';
import './footerlink.css';

const FooterLink = ( { name } ) => {
  return (
    <div className='footer__link-text'>{name}</div>
  )
}

export default FooterLink